export enum VoiceAgentAnalysisResultName {
  SENSITIVE_INFORMATION = 'SENSITIVE_INFORMATION',
  FRUSTRATION = 'FRUSTRATION',
  DIFFICULTY_BOOKING = 'DIFFICULTY_BOOKING',
  CONNECTION_ISSUES = 'CONNECTION_ISSUES',
  LANGUAGE_BARRIERS = 'LANGUAGE_BARRIERS',
}
